import { useTranslation } from "react-i18next";
import dark from "../../assets/brand/logo-dark.png";
import darkWordmark from "../../assets/brand/logo-dark-wordmark.png";
import full from "../../assets/brand/logo-full.png";
import icon from "../../assets/brand/logo-icon.png";
import mark from "../../assets/brand/logo-mark.png";
import wordmark from "../../assets/brand/logo-wordmark.png";

/**
 * The OFFICIAL Astro Planet For Kids logo, cropped from the brand slides (see /branding): never recreated or recoloured.
 *  full          astronaut + wordmark, for light backgrounds (login, splash)
 *  wordmark      "AstroPlanet FOR KIDS", for light backgrounds
 *  dark          full lockup with the white wordmark, for dark backgrounds
 *  darkWordmark  white wordmark only, for dark headers
 *  mark          astronaut-on-planet only
 *  icon          the square app-icon tile
 */
const SRC = { full, wordmark, dark, darkWordmark, mark, icon } as const;

export type LogoVariant = keyof typeof SRC;

export function Logo({ variant, className = "" }: { variant: LogoVariant; className?: string }) {
  const { t } = useTranslation();
  // width auto + a height class from the caller keeps the official proportions; the logo is never stretched
  return <img src={SRC[variant]} alt={t("brand.logoAlt")} className={`w-auto select-none object-contain ${className}`} draggable={false} data-logo={variant} />;
}
